<template>
  <button 
    class="product-button"
    @click="handleClick"
    :disabled="disabled"
  >
    <i class="mdi mdi-package-variant product-icon"></i>
    <span class="product-name">{{ product.name }}</span>
  </button>
</template>

<script>
export default {
  name: 'ProductButton',
  props: {
    product: {
      type: Object,
      required: true
      // Expected structure:
      // {
      //   id: 1,
      //   name: 'Product Name'
      // }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick() {
      if (!this.disabled) {
        // Emit click event to parent (ChatMessage)
        this.$emit('click', this.product);
      }
    }
  }
}
</script>

<style scoped>
.product-button {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  color: white;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: left;
  width: 100%;
}

.product-button:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.product-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.product-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.product-button:disabled:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.3);
  transform: none;
  box-shadow: none;
}

.product-icon {
  font-size: 24px;
  flex-shrink: 0;
}

.product-name {
  flex: 1;
}
</style>